// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"b36f0bd0","36":"28c0aad9","156":"ad194f00","217":"5b1f6784","222":"6eb7e943","295":"2f87cc38","302":"5c492273","450":"4e8d37e9","453":"a65c8953","523":"94973159","534":"23c26548","893":"6681f91e","910":"8cb39961"}[chunkId] + ".chunk.js";
};